import { adminClient, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import {
  type AuthClientCheckSlugResponse,
  AuthClientCheckSlugResponseSchema,
  type AuthClientMembershipResponse,
  AuthClientMembershipResponseSchema,
  type AuthClientSessionResponse,
  AuthClientSessionResponseSchema,
} from './auth-client.types'

const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_BETTER_AUTH_BASE_URL || 'http://localhost:3000',
  basePath: '/auth',
  plugins: [organizationClient(), adminClient()],
  fetchOptions: {
    credentials: 'include', // CRITICAL: Send cookies with every request
  },
  user: {
    additionalFields: {
      lastName: { type: 'string', required: true },
    },
  },
})

export const { signIn, signUp, signOut, useSession, admin } = authClient

// === Re-export better-auth client functions with response types validation ===

export async function getSession(): Promise<AuthClientSessionResponse> {
  try {
    const response = await authClient.getSession()
    return AuthClientSessionResponseSchema.parse(response)
  } catch (error) {
    console.error('getSession validation error:', error)
    throw error
  }
}

export async function getActiveMember(): Promise<AuthClientMembershipResponse> {
  try {
    const response = await authClient.organization.getActiveMember()
    return AuthClientMembershipResponseSchema.parse(response)
  } catch (error) {
    console.error('getActiveMember validation error:', error)
    throw error
  }
}

export async function checkSlug(params: { slug: string }): Promise<AuthClientCheckSlugResponse> {
  try {
    const response = await authClient.organization.checkSlug(params)
    console.log('checkSlug', response)
    return AuthClientCheckSlugResponseSchema.parse(response)
  } catch (error) {
    console.error('checkSlug validation error:', error)
    throw error
  }
}
